import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useQuery } from '@tanstack/react-query';
import { timerSessaoExpiracao } from "../../utils/enum";
import * as LoginManager from "../../../features/login/LoginManager";

const PollingTempoExpiracao = props => {
    const { expiracaoTokenEmMinutos, estaAutenticado, atualizarTempoExpiracao } = props;
    const [primeiroAcesso, setPrimeiroAcesso] = useState(true);

    const fetch = () => {
        const expiracaoEmMinutos = expiracaoTokenEmMinutos ?? 0;

        if (primeiroAcesso) {
            setPrimeiroAcesso(false);
            return expiracaoEmMinutos > 0 ? expiracaoEmMinutos : 0;
        }

        return expiracaoEmMinutos > 0 ? expiracaoEmMinutos - 1 : 0;
    };

    const { data } = useQuery(['fetchSessaoPolling'], fetch, {
        refetchInterval: timerSessaoExpiracao.IntervalMs,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
        enabled: estaAutenticado
    });

    useEffect(() => {
        if (data && estaAutenticado) {
            const minutosExpiracao = data ?? 0;
            atualizarTempoExpiracao(minutosExpiracao);
        }
    }, [data, estaAutenticado, atualizarTempoExpiracao]);

    return null;
};

const mapStateToProps = state => {
    return {
        expiracaoTokenEmMinutos: state.login.usuario && state.login.usuario.expiracaoTokenEmMinutos,
        estaAutenticado: state.login.usuario != null,
    };
};

const mapDispatchToProps = {
    atualizarTempoExpiracao: minutos => LoginManager.atualizarTempoExpiracaoToken(minutos)
};

export default connect(mapStateToProps, mapDispatchToProps)(PollingTempoExpiracao);